import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import ChatPanel from "@/components/chat/ChatPanel";

export default function ConciergeWidget() {
  const [open, setOpen] = useState(false);
  const [ping, setPing] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    const t = setTimeout(() => setPing(false), 8000);
    return () => clearTimeout(t);
  }, []);

  if (pathname.startsWith("/deck")) return null;

  return (
    <>
      {/* Floating trigger button */}
      <button
        data-testid="concierge-toggle"
        onClick={() => {
          setOpen((v) => !v);
          setPing(false);
        }}
        className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[55] h-14 w-14 rounded-full bg-teal text-[#050A0F] grid place-items-center shadow-2xl hover:opacity-90 transition glow-teal"
        aria-label={open ? "Close concierge" : "Open concierge"}
      >
        {open ? <X size={20} /> : <MessageCircle size={22} />}
        {!open && ping && (
          <span className="absolute inset-0 rounded-full border-2 border-teal concierge-ring" />
        )}
      </button>

      {/* Chat overlay */}
      {open && (
        <div
          data-testid="concierge-panel"
          className="fixed bottom-24 right-4 md:right-6 z-[54] w-[min(400px,calc(100vw-2rem))] h-[min(560px,70vh)] rounded-2xl border border-white/[0.08] shadow-2xl overflow-hidden concierge-in"
        >
          <ChatPanel
            mode="concierge"
            sessionKey="concierge"
            title="RevGrow AI Concierge"
            subtitle="Ask anything · Gemini 2.5 Flash"
            placeholder="What do you want to know?"
            initialMessage={"Hi 👋 I'm the RevGrow concierge. I can walk you through our services, the AI-Native Lead Gen Framework, case studies, or help you decide who to speak to next. What's on your mind?"}
            suggestions={[
              "What does RevGrow do?",
              "Explain the AI-Native framework",
              "Which industries do you serve?",
              "How does lead qualification work?",
            ]}
          />
        </div>
      )}

      <style>{`
        @keyframes conciergeRing {
          0% { transform: scale(1); opacity: 0.7; }
          100% { transform: scale(1.6); opacity: 0; }
        }
        .concierge-ring { animation: conciergeRing 1.6s ease-out infinite; }

        @keyframes conciergeIn {
          from { opacity: 0; transform: translateY(12px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .concierge-in { animation: conciergeIn 260ms cubic-bezier(0.22, 1, 0.36, 1); }
      `}</style>
    </>
  );
}
